<template>
	<div id="app">
		<main>
			<router-view></router-view>
		</main>
	</div>
</template>

<script>
	import tracker from "@/mixins/trackerScripts";
	export default {
		name: "app",
		head: {
			title: function () {
				return {
					inner: this.title,
				};
			},
			meta: function () {
				return [
					{
						property: "og:image",
						content: localStorage.getItem("ogImage"),
					},
					{
						property: "og:description",
						content: localStorage.getItem("ogDescription"),
					},
				];
			},
			link: function () {
				return [
					{
						rel: "apple-touch-icon",
						id: "appleTouchIcon",
						href: localStorage.getItem("appleIcon"),
					},
				];
			},
		},
		methods: {
			changeAppleTouch() {
				var link = document.getElementById("appleTouchIcon");
				let url = window.location.hostname;
				if (url == "painel.ulisite.com" || url == "painel.uli.pt") {
					this.$store.commit(
						"UPDATE_APPLETOUCH",
						"static/img/icons/appleIconUli.png"
					);
				} else if (url == "painel.sitejet.com.br") {
					this.$store.commit(
						"UPDATE_APPLETOUCH",
						"static/img/icons/appleIconSitejet.png"
					);
				} else if (url == "painel.fastsite.me") {
					this.$store.commit(
						"UPDATE_APPLETOUCH",
						"static/img/icons/appleIconFastSite.png"
					);
				} else {
					this.$store.commit(
						"UPDATE_APPLETOUCH",
						"static/img/icons/appleIconUli.png"
					);
				}
			},
			brandImage() {
				let url = window.location.hostname;
				if (url === "painel.sitejet.com.br") {
					return "https://sitejet.com.br/img/Logo-Sitejet.png";
				} else {
					return "https://ulisite.com/img/logo-uli.svg";
				}
			},
			isLogin(){
				let historyName = this.$router.history.current.name
				return historyName != 'Login' && historyName != 'LoginApplication' && historyName != 'Checkout'
			},
            //botao whatsapp suporte
            whatsAppButton() {
                const mensagem = this.whatsAppMessage

                const element = document.createElement("div");
                element.style.position = 'fixed';
                element.style.bottom = '30px';
                element.style.right = '30px';
                element.style.zIndex = '9999';
                element.id = "whatsapp-suporte";

                const link = document.createElement("a");
                link.href = `https://wa.me/17981630625?text=${encodeURIComponent(mensagem)}`;
                link.target = "_blank";

                const img = document.createElement("img");
                img.src = "https://epics-public-files.s3.us-east-1.amazonaws.com/images/whatsapp.png";
                img.alt = "Suporte EPICS";

                link.appendChild(img);
                element.appendChild(link);
                document.body.appendChild(element);
            }
		},
        computed: {
            user() {
                return this.$store.state.user;
            },
            whatsAppMessage() {
                const nome = this.user?.name || 'Não informado';
                const email = this.user?.email || 'Não informado';

                return (
                    "Olá, preciso de ajuda do suporte. Abaixo estão meus dados:\n\n" +
                    `Nome: ${nome}\n` +
                    `Email: ${email}\n`
                );
	        }
        },
		mounted() {
			setTimeout(() => {
                this.whatsAppButton();
				this.initTracker();
				this.registerTracker(window.location.href, "page_access");
			}, 5000);
		},
		beforeMount() {
			document.documentElement.style.setProperty(
				"--main-color",
				localStorage.getItem("themeColor")
			);
			document.documentElement.style.setProperty(
				"--bg-color",
				localStorage.getItem("backgroundColor")
			);
		},
		created() {
			if (localStorage.getItem("jwt") && this.isLogin()) {
				this.$store.dispatch("VERIFY_TOKEN");
				this.$store.dispatch("VERIFY_SITE");
			}
            //Clarity microsoft adriano@ulisite
            if(process.env.NODE_ENV == 'production'){
                (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "byvqdc9hv3");
            }

            //Octadesk
            // (function(o, c, t, a, d, e, s, k) {
            //     o.octadesk = o.octadesk || {};
            //     o.octadesk.chatOptions = {
            //         subDomain: a,
            //         showButton: d,
            //         openOnMessage: e,
            //         showFooterPoweredBy: k,
            //         hide: s
            //     };
            //     var bd = c.getElementsByTagName("body")[0];
            //     var sc = c.createElement("script");
            //     sc.async = 1;
            //     sc.src = t;
            //     bd.appendChild(sc);
            // })(window, document, 'https://cdn.octadesk.com/embed.js', 'o208657-5aa', 'true', 'true', 'false', 'false');
			// this.changeAppleTouch();
		},
        data() {
            return {
                whatsAppLoaded: false
            }
        },
        watch: {
            user: {
                handler(newVal) {
                    if (
                        !this.whatsAppLoaded &&
                        newVal &&
                        newVal.name &&
                        newVal.email &&
                        !document.querySelector('#whatsapp-suporte')
                    ) {
                        this.whatsAppButton();
                        this.whatsAppLoaded = true;
                    }
                },
            immediate: true,
            deep: true
            }
            // user(newVal) {
            //     const loginToChat = () => {
			// 	if (window.octadesk?.chat?.login) {
			// 		octadesk.chat.login({
			// 			name: newVal.name,
			// 			email: newVal.email,
			// 		});
			// 	} else {
			// 		// tenta de novo depois de um tempo
			// 		setTimeout(loginToChat, 300);
			// 	}
			// };
			// loginToChat();
            // }
        },
		// mixins: [tracker],
	};
</script>

<style>
	:root {
		--main-color: #6828e8;
		--bg-color: #5b28b9;
		--text-dark: #222;
		--error-color: #ff4a51;
	}
	body {
		margin: 0;
		font-family: "Open Sans", sans-serif;
		font-weight: 400;
		color: #111;
		background-repeat: no-repeat !important;
		background-position: top center !important;
	}

	b {
		font-weight: 700;
	}

	body.uli {
		background-image: url("../src/assets/img/Uli-Fundo-Painel-desk.png") !important;
	}

	body.others {
		background-image: url("../src/assets/img/Uli-Fundo-Painel-desk-cinza.png");
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	html {
		scroll-behavior: smooth;
	}

	#app {
		position: absolute;
		width: 100%;
		height: 100%;
	}
	.error-message {
		color: var(--error-color);
	}
	.remove-message {
		color: #777777;
	}
	#cadastroParte2 {
		display: none;
	}
	#cadastroParte3 {
		display: none;
	}
	.pointer {
		cursor: pointer;
	}
	.creation {
		min-height: 130px;
	}
	.creation-2 {
		padding-top: 10px;
		min-height: 140px;
	}
	.confirm-conect {
		color: var(--main-color);
	}
	.confirm-conect:hover {
		cursor: pointer;
	}
	.confirm-conect,
	.confirm-disconect {
		font-size: 1em;
		font-weight: 700;
		font-family: "Montserrat", sans-serif;
	}
	.confirm-disconect {
		color: var(--main-color);
		cursor: pointer;
	}
	.inactive-api {
		opacity: 0.4;
	}
	.inactive-api:hover {
		cursor: pointer;
	}
	@media all and (min-width: 768px) {
		.creation {
			padding-top: 20px;
			padding-bottom: 40px;
		}
	}
    @media (max-width: 768px) {
        #octadesk-octachat-appchat {
            margin: 10px !important;
        }
    }
	.total-api-list {
		overflow-x: hidden !important;
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	.api-list {
		height: 180px;
		overflow-x: auto;
		white-space: nowrap;
		position: relative;
		left: 0;
		right: 0;
		padding: 0 1rem;
	}
	.item-api-list {
		height: 140px;
		margin: 0 10px;
		display: inline-block;
		width: 110px;
		text-align: center;
	}
	.icon-api-list {
		height: 110px;
		width: 110px;
		border-radius: 10px;
		padding-top: 25px;
		margin-bottom: 10px;
		color: #ffffff;
		font-weight: 400;
		font-size: 13px;
	}
	.icon-api-list p {
		margin-top: 5px;
	}
	.logo-api {
		height: 40px;
	}
	.api-instagram {
		background: linear-gradient(to bottom right, purple, orange);
	}
	.api-facebook {
		background-color: #4267b2;
	}
	.api-behance {
		background-color: #6828e8;
	}
	.api-tripadvisor {
		background-color: #00a680;
	}
	.api-foursquare {
		background-color: rgb(45, 91, 227);
	}
	.api-ifood {
		background-color: #bc2026;
	}
	.api-twitter {
		background-color: #1da1f2;
	}
	.api-youtube {
		background-color: #ff0000;
	}
	.api-whatsapp {
		background-color: #25d366;
	}
	.item-api-list .logo-api img {
		width: 36px;
	}
	.item-api-list .user--avatar img {
		width: 56px;
		border-radius: 50%;
	}
	.total-integrations-list {
		overflow-x: hidden !important;
		position: relative;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
	.integrations-list {
		min-height: 160px;
		overflow-x: scroll;
		white-space: nowrap;
		position: relative;
		left: 0;
		right: 0;
		padding: 5px 0;
	}
	.integration-item {
		box-shadow: 0 0 9px 1px #e4e4e4;
		border-radius: 5px;
		padding: 10px;
		height: 260px;
		width: 270px;
		margin: 0 7px;
		display: inline-block;
		text-align: center;
	}
	.integration-item img {
		height: 30px;
	}
	.integration-item .classification {
		padding: 4px 8px;
		border-radius: 50px;
		background-color: #fff;
		color: yellow;
		font-size: 1.2em;
	}
	.facebook .classification {
		background-color: var(--main-color);
		color: #fff;
	}
	.ifood .classification {
		background-color: #f00;
		color: #fff;
	}
	.ifood .classification {
		background-color: #1da1f2;
		color: #fff;
	}
	.btnEtapa1 {
		top: -10px;
	}
	.btnVoltar {
		padding-top: 15px;
	}
	.scroll-custom::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	@media all and (max-width: 998px) {
		body {
			background-size: cover;
			background-attachment: fixed;
		}
		body.uli {
			background-image: url("../src/assets/img/Uli-Fundo-Painel-mobile.png");
		}
		body.others {
			background-image: url("../src/assets/img/Uli-Fundo-Painel-mobile-cinza.png");
		}
		.total-btn-check {
			position: absolute;
			bottom: 0;
			right: 0;
			left: 0;
		}
		h1 {
			font-size: 24px;
		}
		.image-likes {
			left: 20px;
			bottom: 20px;
		}
	}
	/* Handle */
	.scroll-custom::-webkit-scrollbar-thumb {
		background: var(--main-color);
		border-radius: 10px;
	}

	/* Handle on hover */
	.scroll-custom::-webkit-scrollbar-thumb:hover {
		background: var(--main-color);
	}

	.fixa-btn {
		position: absolute;
		bottom: 0;
	}

	.item-content {
		height: 220px;
	}

	.uli-btn {
		padding: 8px 16px;
		border: none;
		color: #fff;
		font-weight: 700;
		border-radius: 20px;
		min-width: 80px;
		cursor: pointer;
	}

	.btn-secundario {
		background-color: #f2f2f2;
		color: #858585;
	}

	.modal-header {
		border-bottom: none !important;
	}

	.uli-btn-success {
		background-color: #6828e8;
	}

	.uli-btn-cancel {
		background-color: #cecece;
	}
	.default_input,
	.input-picker,
	.form-control,
	.search-input,
	#app input[type="text"],
	#app input[type="email"],
	#app input[type="password"],
	#app input[type="phone"],
	#app input[type="tel"],
	#app textarea,
	#app input[type="date"],
	#app select {
		border: none;
		border-bottom: 1px solid #dddddd;
		border-radius: 0;
		padding-left: 0;
		padding-right: 0;
	}
	.default_input:focus,
	.form-control:focus,
	.input-picker:focus,
	.form-control:focus,
	.form-control:active,
	#app input[type="text"]:focus,
	#app input[type="email"]:focus,
	#app input[type="password"]:focus,
	#app input[type="tel"]:focus,
	#app input[type="phone"]:focus,
	#app textarea:focus,
	#app input[type="date"]:focus,
	#app select:focus {
		border: none;
		outline: none !important;
		border-bottom: 1px solid var(--main-color) !important;
		-webkit-box-shadow: none !important;
		box-shadow: none !important;
	}
	.next-btn {
		font-size: 1.5em;
		font-weight: 700;
		position: absolute;
		bottom: 0;
		width: 100%;
		padding-bottom: 8px;
	}
	.next-btn .fas {
		color: var(--main-color);
		font-size: 2em;
	}
	.back-btn {
		color: rgb(119, 119, 119);
	}
	.back-btn:hover {
		cursor: pointer;
	}
	.btn-extra-small {
		height: 24px;
		font-size: 12px;
		padding-left: 16px;
		padding-right: 16px;
	}
	.btn-small {
		height: 35px;
		font-size: 12px;
		padding-left: 24px;
		padding: 0.5rem 1rem;
		padding-right: 24px;
	}
	.small--text {
		font-size: 11px;
		color: #cccccc;
		cursor: pointer;
	}
	.btn-xsmall {
		height: 24px;
		font-size: 14px;
		padding-top: 2px;
		padding-bottom: 2px;
		padding-left: 15px;
		padding-right: 15px;
	}
	.btn-medium {
		height: 40px;
		font-size: 16px;
		padding-left: 32px;
		padding-right: 32px;
	}
	.btn-large {
		font-size: 16px;
	}
	.btn-extra-large {
		height: 60px;
		font-size: 18px;
		padding-left: 40px;
		padding-right: 40px;
	}
	.btn-primario {
		background-color: var(--main-color);
		color: white;
        filter: brightness(1);
        transition: all 200ms ease;
	}
	.btn-primario:hover {
		color: #fff;
        filter: brightness(0.85);
        transition: all 200ms ease;
	}
	.btn-primario:disabled {
		background-color: #dddddd;
	}
	.btn-primario-outline {
		border: 2px solid var(--main-color);
		background-color: transparent;
		color: var(--main-color);
		transition: all 0.3s;
		font-weight: 400;
	}
	.btn-primario-outline:hover {
		background-color: var(--main-color);
		color: rgb(255, 255, 255);
	}
	.btn-fixed {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 20px;
		z-index: 3;
	}
	.pin-picture img {
		height: 10px;
	}
	.center img {
		width: 121px !important;
		height: 121px !important;
		object-fit: cover;
		margin-top: 0px !important;
		box-shadow: 0 0 9px 1px #e4e4e4;
		opacity: 100 !important;
	}
	.get-start {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ffffffcc;
	}
	.guia-etapas {
		margin-right: 8px;
	}
	.custom-radio {
		padding-top: 10px;
		padding-bottom: 10px;
		border-top: 1px solid #555;
		border-bottom: 1px solid #555;
	}
	.slide-galery img {
		width: 25%;
		height: auto;
		margin: 3px;
		border-radius: 7px;
	}
	.grid-item label {
		margin-bottom: 0px;
	}
	.grid-item img {
		width: 100%;
		border-radius: 7px;
	}
	.grid-item {
		position: relative;
		border: 4px solid #ffffff00;
	}
	.total-slide {
		height: 60px;
	}
	.itemActive {
		border: 4px solid var(--main-color);
		border-radius: 12px;
	}
	.item-slide {
		width: 56px;
		height: 56px;
		background-color: #c9c9c9;
		display: inline-block;
		margin: 0 3px 20px;
	}
	.item-slide img {
		width: 56px;
		height: 56px;
		object-fit: cover;
		border-radius: 7px;
	}
	.total-carousel {
		min-height: 170px;
		padding: 0;
		border-radius: 8px;
	}
	.carousel-3d-slide {
		background-color: #fff !important;
	}
	.total-card {
		box-shadow: 0 3px 6px #00000029;
		border-radius: 6px;
		margin-bottom: 70px;
	}
	.total-card :hover {
		box-shadow: 0 6px 16px #00000029;
	}
	.card-body {
		padding: 10px 24px 10px;
	}
	.card-body * {
		box-shadow: none !important;
	}
	.card-body *:hover {
		box-shadow: none !important;
	}
	.card-footer .card-link {
		font-weight: 700;
	}
	.card-footer .edit-link {
		color: var(--main-color);
	}
	.card-footer .delete-link {
		color: darkgrey;
	}
	.card-body .card-title {
		font-size: 18px;
		font-weight: 700;
	}
	.card-body .card-text {
		font-size: 16px;
	}
	.big-text {
		font-size: 1.2em;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100%;
		white-space: nowrap;
	}
	.menu-component label {
		margin-bottom: 0;
		font-size: 0.85rem;
		color: rgba(0, 0, 0, 0.32);
		font-weight: 700;
		font-size: 0.6rem;
	}
	.btn:focus,
	.btn.focus {
		outline: 0;
		box-shadow: none !important;
	}
	.simple-link:hover {
		cursor: pointer;
	}
	@media (min-width: 450px) {
		.grid {
			-webkit-column-count: 3;
			-moz-column-count: 3;
			column-count: 3;
		}
	}
	@media (min-width: 650px) {
		.grid {
			-webkit-column-count: 3;
			-moz-column-count: 3;
			column-count: 3;
		}
	}

	@media (min-width: 960px) {
		.grid {
			-webkit-column-count: 4;
			-moz-column-count: 4;
			column-count: 4;
		}
		.item-slide {
			width: 100px;
			height: 100px;
		}
		.item-slide img {
			width: 100px;
			height: 100px;
		}
	}
	.add-avatar {
		color: var(--main-color);
		padding: 10px 13px;
		border-radius: 25px;
		font-size: 0.9rem;
		font-family: "Montserrat", sans-serif;
	}
	.add-avatar:hover {
		cursor: pointer;
	}
	.img-carousel {
		width: 120px !important;
		height: 116px !important;
		object-fit: cover;
		opacity: 0.4;
	}
	.current .img-carousel {
		opacity: 1 !important;
		box-shadow: 0 3px 3px #00000029;
	}
	.position-slider {
		background-color: var(--main-color);
		color: #fff;
		border-radius: 25px;
		padding: 5px 11px;
		position: absolute;
		top: 20px;
		right: 20px;
		font-size: 0.8rem;
		font-family: "Montserrat", sans-serif;
	}
	.details {
		color: #fff;
		font-family: "Montserrat", sans-serif;
		position: absolute;
		bottom: 20px;
		z-index: 3;
	}
	.details i {
		color: #fff;
	}
	.image-likes {
		left: 40px;
	}
	.image-comments {
		right: 40px;
	}
	@media all and (max-width: 500px) {
		.grid-item img {
			object-fit: cover;
		}
		.details {
			font-size: 10px;
		}
		.image-likes {
			left: 10px;
			bottom: 10px;
		}
		.image-comments {
			right: 10px;
			bottom: 10px;
		}
		.position-slider {
			top: 5px;
			right: 5px;
		}
	}
	.image-overlay {
		z-index: 2;
		position: absolute;
		top: 4px;
		left: 0px;
		right: 0px;
		bottom: 0px;
		border-radius: 5px;
		background-image: linear-gradient(to bottom, transparent 50%, #0d0d0d9e);
	}
	.card-buttons {
		position: absolute;
		bottom: 10px;
		left: 15px;
		right: 15px;
	}
	.card-buttons a {
		color: var(--main-color);
	}
	.reverse-pin img {
		transform: rotate(180deg);
		height: 10px;
	}
	.colapsed {
		height: 280px !important;
	}
	.subtext {
		font-size: 16px;
		/* color: rgb(119, 119, 119); */
		line-height: 19px;
		margin-bottom: 0;
	}
	.btn:disabled {
		opacity: 1;
	}
	.btn-disabled,
	.btn-disabled:hover {
		background-color: #ddd;
		color: #fff;
	}
	.btn-white {
		background-color: #ffffff;
		color: var(--main-color) !important;
	}
	.custom-control-input:checked ~ .custom-control-label::before {
		border-color: var(--main-color) !important;
		background-color: var(--main-color) !important;
	}
	.svg-icon path {
		fill: var(--main-color);
	}
	.round-fa {
		color: var(--main-color);
	}

		.suggestions{
		text-align: initial;
    	padding-bottom: 15px;
	}
	.alert-maintance {
		color: #fff;
		font-weight: 700;
		background-color: orange;
	}
	@media all and (max-width: 700px) {
		.alert-maintance {
			color: #fff;
			font-weight: 700;
			background-color: orange;
			font-size: 12px;
		}
	}
	.total-welcome {
		background-color: #000000c2;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 9;
	}
	.total-welcome .welcome-message p {
		font-size: 17px;
		color: #fff;
		font-family: "Montserrat", sans-serif;
	}
	.total-welcome .welcome-baloon {
		display: inline-block;
		background-color: #ffffff;
		border-radius: 10px;
		box-shadow: 0px 6px 40px 7px #00000045;
		padding: 20px 5px;
		max-width: 285px;
		width: 100%;
		position: relative;
	}
	.total-welcome .welcome-baloon:after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		width: 0;
		height: 0;
		border: 17px solid transparent;
		border-top-color: #fff;
		border-bottom: 0;
		margin-left: -17px;
		margin-bottom: -17px;
	}
	.total-welcome .welcome-baloon .okay-button {
		color: var(--main-color);
	}
	.total-welcome .welcome-baloon .okay-button:hover {
		cursor: pointer;
	}

	.categories a {
		display: inline-flex;
	}

	.categories a.active {
		color: rgba(0, 0, 0, 1);
		border-color: transparent !important;
	}
	.categories a.active::after {
		content: " ";
		display: inline-block;
		width: 6px;
		height: 6px;
		position: relative;
		border-radius: 50px;
		background: var(--main-color);
		bottom: -25px;
		left: -50%;
	}

	@media all and (min-width: 998px) {
		/* .categories a.active::after {
			bottom: -20px;
			left: calc(-50% + 3px);
		} */
	}

	/* NAV TABS */
	.nav.nav-tabs {
		padding: 2rem 0;
	}

	.nav.nav-tabs a {
		padding: 0;
		white-space: nowrap;
	}

	.nav.nav-tabs a i,
	.nav.nav-tabs a svg {
		padding: 0;
		opacity: 0.4;
		color: var(--text-dark);
		transition: opacity 0.2s ease;
	}

	.nav.nav-tabs a span {
		font-weight: 600;
		opacity: 0.4;
		color: var(--text-dark);
		transition: opacity 0.2s ease;
		font-family: "Montserrat", sans-serif;
	}

	.nav-tabs .nav-link .news--class {
		color: #ffffff;
		opacity: 1;
		border-radius: 50px;
		padding: 4px 0.85rem;
		background-color: #6cd571;
	}

	.nav-tabs .nav-link.active span,
	.nav-tabs .nav-link span:hover,
	.nav.nav-tabs a:hover svg,
	.nav.nav-tabs a:hover i {
		opacity: 1;
	}

	.nav-tabs .nav-item {
		padding: 0 1rem;
	}

	.post-content {
		margin-bottom: 25px;
	}

	.nav {
		flex-wrap: nowrap;
		overflow-x: auto;
		overflow-y: hidden;
	}

	.nav-tabs {
		border: none;
	}

	.nav-tabs .nav-link:hover,
	.nav-tabs .nav-link:focus {
		border-color: transparent;
		outline: none;
	}

	.nav-tabs .nav-link.active {
		background-color: transparent;
	}

	.pending-bill{
		padding-top: 10px;
		padding-bottom: 10px;
		background: #FF4A5133 0% 0% no-repeat padding-box;
		opacity: 1;
	}
	/* ----- */
	/* ----- CardTemplate ---- */

#cardTemplate {
  display: grid;
}
#cardTemplate .card {
  grid-column: 1;
  grid-row: 1/3;
  min-height: 220px;
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.16);
  font-size: 14px;
  border: none;
  text-align: left;
  white-space: normal;
}
#cardTemplate .card-alert {
  display: flex;
  grid-column: 1;
  grid-row: 1/4;
  align-items: center;
  justify-content: center;
  background-color: #f8f8fae6;
  color: #333;
  padding: 20px;
  z-index: 2;
  font-weight: 700;
  font-size: 16px;
}
.card-summary {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.card-alert button {
  border-radius: 50px;
  margin: 10px 8px;
  padding: 8px;
  min-width: 104px;
  background: none;
  border: none;
  color: #f2f2f2;
}
.card-alert button.confirm-button {
  background-color: #777777;
}
.card-alert button.cancel-button {
  background-color: var(--main-color);
}
.card-img-top {
  height: 157px;
  object-fit: cover;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.card-footer {
  background-color: white;
  border: none;
  border-radius: 0 0 6px 6px;
}
.card-footer .delete-link {
  color: #c8c8c8;
}
.card-footer .edit-link {
  color: var(--main-color);
}
.molecula-data-tipo span {
  padding: 5px 0;
}
.type-post {
  color: rgba(0, 0, 0, 0.45);
  background-color: #f2f2f2;
  border-radius: 15px;
  padding: 5px 15px !important;
}

.item-settings-button {
  background-color: #f8f8fa;
  color: #222;
  cursor: pointer;
	min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  margin-top: 4px;
}
.item-settings-button:disabled {
  background-color: #6c757d98;
  cursor:no-drop;
}
.item-settings-button:disabled:hover {
  background-color: #6c757d98;
}
.item-settings-button:hover {
  color: #fff;
  background: var(--main-color);
}
.checkout-page {
	position: absolute;
	width: 100%;
	height: 100%;
	padding: 15px 0;
}
.checkout-page .container {
	max-width: 457px;
	min-height: 100%;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 50px 80px 1fr minmax(min-content, auto) 75px;
}
.checkout-page .active--cupom {
	font-weight: 700;
}
.checkout-page .back--button {
	color: var(--main-color);
	cursor: pointer;
}
.checkout-page .cupom--text {
	font-size: 11px;
	color: #cccccc;
	cursor: pointer;
	position: absolute;
  right: 0;
}
.checkout-page .list--plans {
	align-content: start;
	display: grid;
	grid-gap: 15px;
	grid-template-columns: 1fr;
	padding: 0 15px;
}
.checkout-page .list--plans .values--anual {
	color: #cccccc;
	font-size: 0.62rem;
	margin-bottom: 5px;
	text-align: left;
}
.checkout-page .list--plans .total--anual {
	font-weight: 700;
	text-align: left;
	margin-bottom: 0;
}
.checkout-page .form--items {
	align-content: start;
	padding: 0 15px;
}
.checkout-page .form--items .item--form {
	margin: 7px 0;
}
.checkout-page .list--plans .form-group label {
	color: #cccccc;
	font-size: 0.62rem;
	margin-bottom: 0;
}
.checkout-page .item--form label {
	color: #cccccc;
	margin-bottom: 0;
}
.checkout-page .list--errors {
	margin: 0;
	text-align: left;
	padding: 0;
}
.checkout-page .list--errors li {
	list-style: none;
	color: #d61a1a;
}
.loading--spinner {
	color: var(--main-color);
}
.error--cupom {
	color: #d61a1a;
	margin-top: 15px;
	font-size: 0.8rem;
}
.checkout-page .link--boleto {
	color: var(--main-color);
}
.checkout-page .label--boleto {
	color: #cccccc;
	font-size: 0.8rem;
}
.checkout-page .link--boleto:hover {
	text-decoration: none;
}
.checkout-page .link--boleto span i {
	font-size: 1.2rem;
}
.value--off{
	text-decoration: line-through;
}
.card.active{
	border: 2px solid var(--main-color);
}
/* Classe de erro menu lateral */
.errors{
  color: rgb(220, 53, 69);
  font-size: 11px;
}
/* Classe de erro do modal*/
.checkout-page .errors{
    color: rgb(220, 53, 69);
    font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue